import { render } from "./companyCardQuota.vue?vue&type=template&id=5d9ea0eb&scoped=true"
import script from "./companyCardQuota.vue?vue&type=script&lang=js"
export * from "./companyCardQuota.vue?vue&type=script&lang=js"

import "./companyCardQuota.vue?vue&type=style&index=0&id=5d9ea0eb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5d9ea0eb"

export default script